export default "__VITE_ASSET__7cd72e48__"